import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

import { ApiAuthService } from '@services/api-auth.service';
import { SharedService } from '@services/shared.service';

import { VendorStoreCustomer } from '@shared/models/VendorModel';


@Component({
    selector: 'app-gsa-account-info',
    templateUrl: './gsa-account-info.component.html',
    styleUrls: ['./gsa-account-info.component.scss']
})
export class GsaAccountInfoComponent implements OnInit {

    @Output() changeStore: EventEmitter<boolean> = new EventEmitter();

    @Input() viewNumber: number = 0;/* 0 == dashboard; 1 == account; */

    store: VendorStoreCustomer;

    constructor(public sharedService: SharedService,
        public router: Router,
        private apiAuthService: ApiAuthService) { }

    ngOnInit(): void {

        // Check if exist stored session.
        const session = this.apiAuthService.getGiviScanSession();

        if (session && session.accessToken) {

            this.store = session.selectedStore;

        } else {

            this.router.navigate(['gsa-login']);
        }

        //set the gsa header as true
        this.sharedService.setIsGiViScan(true);
        //set the gsa vendor logo
        this.sharedService.setGiviScanLogo(this.store.logoUrl);
    }

    ongChangeStore() {

        this.changeStore.emit(true);
    }

    onNavigateToScan() {

        this.router.navigate(['gsa-scanner']);
    }

    onNavigateToScanZebra() {

        this.router.navigate(['gsa-scanner-zebra']);
    }

}
